import { render, staticRenderFns } from "./YourRoutineProductsList.vue?vue&type=template&id=36936161&scoped=true&"
import script from "./YourRoutineProductsList.vue?vue&type=script&lang=js&"
export * from "./YourRoutineProductsList.vue?vue&type=script&lang=js&"
import style0 from "./YourRoutineProductsList.vue?vue&type=style&index=0&id=36936161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36936161",
  null
  
)

export default component.exports